import React, { useEffect, useState } from 'react'

export default function PWAStatus() {
  const [online, setOnline] = useState(() => navigator.onLine)
  const [updateReady, setUpdateReady] = useState(false)
  const [registration, setRegistration] = useState(null)

  useEffect(() => {
    const handleOnline = () => setOnline(true)
    const handleOffline = () => setOnline(false)
    const handleUpdate = (event) => {
      setRegistration(event.detail?.registration || null)
      setUpdateReady(true)
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)
    window.addEventListener('mathkids:pwa-update', handleUpdate)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
      window.removeEventListener('mathkids:pwa-update', handleUpdate)
    }
  }, [])

  const applyUpdate = () => {
    registration?.waiting?.postMessage({ type: 'SKIP_WAITING' })
    setUpdateReady(false)
  }

  return (
    <>
      {!online ? (
        <div className="pwa-status-banner" role="status">
          Você está offline. Conteúdos já carregados podem continuar disponíveis; IA, pagamentos e vídeo exigem internet.
        </div>
      ) : null}
      {updateReady ? (
        <div className="pwa-update-banner" role="status">
          <span>Uma nova versão do Math.Kids 3D está disponível.</span>
          <button type="button" onClick={applyUpdate}>Atualizar agora</button>
        </div>
      ) : null}
    </>
  )
}
